import { useState } from 'react';

import { Cloud } from '@cast/shared-types';
import { CloudAssetIntegrationsScope } from '@cast/types-inventory';

import { providerToScopeOptions } from '../_constants';
import { canCommitmentsBeAutoEnabledForAutoscaling } from '../_utils';

type CloudConnectConfig = {
  scope?: CloudAssetIntegrationsScope;
  setScope: (scope?: CloudAssetIntegrationsScope) => void;
  commitmentAutoAssignment?: boolean;
  setCommitmentAutoAssignment: (commitmentAutoAssignment?: boolean) => void;
};

export const useCloudConnectConfig = (provider: Cloud): CloudConnectConfig => {
  const [previousProvider, setPreviousProvider] = useState<Cloud | undefined>(
    provider
  );
  const defaultScope = providerToScopeOptions[provider].at(0)?.value;

  const [scope, _setScope] = useState<CloudAssetIntegrationsScope | undefined>(
    defaultScope
  );
  const [commitmentAutoAssignment, setCommitmentAutoAssignment] = useState<
    boolean | undefined
  >(
    canCommitmentsBeAutoEnabledForAutoscaling(provider, defaultScope) ||
      undefined
  );

  const setScope = (scope: CloudAssetIntegrationsScope | undefined) => {
    _setScope(scope);
    setCommitmentAutoAssignment(
      canCommitmentsBeAutoEnabledForAutoscaling(provider, scope) || undefined
    );
  };

  if (previousProvider !== provider) {
    setPreviousProvider(provider);
    setScope(defaultScope);
  }

  return {
    scope,
    setScope,
    commitmentAutoAssignment,
    setCommitmentAutoAssignment,
  };
};
